'use strict';

function CreateMortgageTray() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController];

  this._secondaryMenuAdded = false;
  this._menu = null;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    this._menu = {
      item_options: {
        title: 'Select your options',
        url: '/member/dashboard/mortgage/new/options',
        analyticsId: 'MogoMortgage-Application Type-Edit-null-Click',
        disabled: false,
        completed: false,
        isComplete: this._isMortgageOptionsComplete.bind(this)
      },
      item_backup: {
        title: 'Co-pilot or solo',
        url: '/member/dashboard/mortgage/new/backup',
        analyticsId: 'MogoMortgage-Applicant Info-Edit-null-Click',
        disabled: true,
        completed: false,
        isComplete: this._isBackupSoloComplete.bind(this)
      },
      item_employmentInfo: {
        title: 'Employment info',
        url: '/member/dashboard/mortgage/new/employment-info',
        analyticsId: 'MogoMortgage-Employment-Edit-null-Click',
        disabled: true,
        completed: false,
        isComplete: this._isEmploymentInfoComplete.bind(this)
      },
      item_liability: {
        title: 'Liability details',
        url: '/member/dashboard/mortgage/new/liability',
        analyticsId: 'MogoMortgage-Liability-Edit-null-Click',
        disabled: true,
        completed: false,
        isComplete: this._isLiabilityDetailsComplete.bind(this)
      },
      item_mortgage: {
        title: 'Your new mortgage',
        url: '/member/dashboard/mortgage/new/details',
        analyticsId: 'MogoMortgage-Details-Edit-null-Click',
        disabled: true,
        completed: false,
        isComplete: this._isMortgageDetailsComplete.bind(this)
      },
      item_consent: {
        title: 'Consent',
        url: '/member/dashboard/mortgage/new/consent',
        analyticsId: 'MogoMortgage-Consent-Edit-null-Click',
        disabled: true,
        completed: false,
        isComplete: this._isConsentCheckComplete.bind(this)
      }
    };

    this.presenter.addComputedVariable('mortgage_type_formatted', ['mortgage.type'], function (type) {
      if (!type) {
        return '';
      }
      if (type == 'pre_approval') {
        return 'mortgage pre-approval';
      }
      if (type == 'refinance') {
        return 'mortgage renewal';
      }
      if (type == 'home_purchase') {
        return 'mortgage home purchase';
      }
      return type;
    });
    $('#tray-navigation').mogo().create('TrayNavigation', {
      steps: {
        items: this._setupMenuItems(),
        sequential: false,
        selectedIndex: 1
      },
      progressIndicator: 'percent'
    });

    mogo.ready(function () {
      _this._navigation = $('#tray-navigation').mogo();
      var traySteps = $('#tray-navigation').mogo()._listItems;
      if (traySteps[traySteps.length - 1].completed == true) {
        _this.disableAllSteps();
      }
    });

    this.presenter.scanDOM(this.node);
  };

  this._setupMenuItems = function () {
    var items = [];
    items.push(this._menu.item_options);
    if (!this.presenter.hasAction('mortgage.update_mortgage_application')) return items;

    this._menu.item_options.completed = this._isMortgageOptionsComplete();
    this._secondaryMenuAdded = true;
    this._nextItem = false;

    if (this._isBackupSoloComplete()) {
      this._menu.item_backup.disabled = !this._menu.item_options.completed;
      this._menu.item_backup.completed = true;
    } else if (!this._nextItem) {
      this._nextItem = true;
      this._menu.item_backup.disabled = !this._menu.item_options.completed;
    }

    if (this._isEmploymentInfoComplete()) {
      this._menu.item_employmentInfo.disabled = this._menu.item_backup.disabled || this._nextItem;
      this._menu.item_employmentInfo.completed = true;
    } else if (!this._nextItem) {
      this._nextItem = true;
      this._menu.item_employmentInfo.disabled = this._menu.item_backup.disabled;
    }

    if (this._isLiabilityDetailsComplete()) {
      this._menu.item_liability.disabled = this._menu.item_employmentInfo.disabled || this._nextItem;
      this._menu.item_liability.completed = true;
    } else if (!this._nextItem) {
      this._nextItem = true;
      this._menu.item_liability.disabled = this._menu.item_employmentInfo.disabled;
    }

    if (this._isMortgageDetailsComplete()) {
      this._menu.item_mortgage.disabled = this._menu.item_liability.disabled || this._nextItem;
      this._menu.item_mortgage.completed = true;
    } else if (!this._nextItem) {
      this._nextItem = true;
      this._menu.item_mortgage.disabled = this._menu.item_liability.disabled;
    }

    if (this._isConsentCheckComplete()) {
      this._menu.item_consent.disabled = this._menu.item_mortgage.disabled || this._nextItem;
      this._menu.item_consent.completed = true;
    } else if (!this._nextItem) {
      this._nextItem = true;
      this._menu.item_consent.disabled = this._menu.item_mortgage.disabled;
    }

    items.push(this._menu.item_backup);
    items.push(this._menu.item_employmentInfo);
    items.push(this._menu.item_liability);
    items.push(this._menu.item_mortgage);
    items.push(this._menu.item_consent);

    return items;
  };

  this.moveNext = function () {
    this._navigation.setCompleted(this._navigation.getSelectedIndex());
    this._navigation.goToNextStep();
    this._navigation.fixStepsCompletion();
    this._updateStepsEnabled();
  };

  this._updateStepsEnabled = function () {
    var menuItems = this._navigation._listItems;
    for (var index = 0; index < menuItems.length; index++) {
      this._navigation.setEnabled(index);
      if (!menuItems[index].completed) return;
    }
  };

  this.initializeSecondaryItems = function () {
    if (!this._secondaryMenuAdded) {
      this._secondaryMenuAdded = true;
      if (this._menu) {
        this._navigation.addMenuItem(this._menu.item_backup);
        this._navigation.addMenuItem(this._menu.item_employmentInfo);
        this._navigation.addMenuItem(this._menu.item_liability);
        this._navigation.addMenuItem(this._menu.item_mortgage);
        this._navigation.addMenuItem(this._menu.item_consent);
      }
    }
  };

  this.disableAllSteps = function () {
    var menuItems = this._navigation._listItems;
    for (var index = 0; index < menuItems.length; index++) {
      this._navigation.setDisabled(index);
      this._navigation.disableEditable(index);
    }
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('mortgage_type_formatted');

    this._super();
  };
}